export const VENUE_URL_SLOT = '{venue}';

export const UAT_MARKER = 'uat';
